import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Lựa chọn vật tư:")
], -1)
const _hoisted_3 = { class: "col-lg-3" }
const _hoisted_4 = { class: "col-lg-3" }
const _hoisted_5 = { class: "col-lg-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.categorySupplyId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categorySupplyId) = $event)),
        placeholder: "Chọn danh mục",
        name: "categorySuppliesId",
        onChange: _ctx.onCategorySelectedHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 0,
            label: 'Không chọn'
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategorySupplies, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.ten_danh_muc,
              "trigger-on-focus": false,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_autocomplete, {
        class: "inline-input",
        modelValue: _ctx.selectedSupplyName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSupplyName) = $event)),
        placeholder: "chọn vật tư",
        "fetch-suggestions": _ctx.querySupply,
        onSelect: _ctx.onSelectedSupplyHandler
      }, null, 8, ["modelValue", "fetch-suggestions", "onSelect"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_input_number, {
        class: "inline-input",
        type: "number",
        modelValue: _ctx.quantity,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quantity) = $event)),
        placeholder: "Số lượng"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", {
      class: "col-lg-2",
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmittedHandler && _ctx.onSubmittedHandler(...args)), ["prevent"]))
    }, [
      _createVNode(_component_el_button, null, {
        default: _withCtx(() => [
          _createTextVNode("Chọn")
        ]),
        _: 1
      })
    ])
  ]))
}